import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ShieldOff = createReactComponent("ShieldOff", ["svg", defaultAttributes, [["path", {
  d: "M19.69 14a6.9 6.9 0 00.31-2V5l-8-3-3.16 1.18",
  key: "1khz6d"
}], ["path", {
  d: "M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 005.62-4.38",
  key: "evw9xz"
}], ["line", {
  x1: "1",
  y1: "1",
  x2: "23",
  y2: "23",
  key: "czowfk"
}]]]);
export default ShieldOff;